import React, { useState } from "react";
import { Col, Row } from "react-bootstrap";
import { ILoginFlows } from "@domains/features/LoginFlow/entities/CommonLoginData";
import { useNavigate } from "react-router-dom";
import { accountDetails } from "@di";
import { Link } from "react-router-dom";
const LoginLogoutsection = (props) => {
    const navigate = useNavigate();
    let [phoneNumber, setPhoneNumber] = useState();
    React.useEffect(() => {
        accountDetails.getAccPhoneNo().then((x) => setPhoneNumber(x));
    }, []);
    return (React.createElement(Row, { className: "mx-0" },
        React.createElement(Col, { lg: 12, className: "loginLogoutsection-grid px-0" },
            props.userType === ILoginFlows.CLIENT && (React.createElement(React.Fragment, null,
                React.createElement("div", null,
                    React.createElement("div", { className: "signup-block" }, props.userName.substring(0, 3))),
                React.createElement("div", null,
                    React.createElement("span", { className: "DMSan_16_700 txt-midnight-blue" }, props.userType),
                    React.createElement("div", { className: "d-flex mgt-15" },
                        React.createElement("span", { className: "DMSanN_14_400 txt_primaryGrey" }, "Cust ID"),
                        React.createElement("span", { className: "DMSanM_14_500 ps-2 txt_blackOne1" }, "45015214")),
                    React.createElement("div", { className: "d-flex mgt-15" },
                        React.createElement("span", { className: "DMSanN_14_400 txt_primaryGrey" }, "Advisor"),
                        React.createElement("span", { className: "DMSanM_14_500 ps-2 txt-midnight-blue txt_underline" }, "Rahul Bhattacharya")),
                    React.createElement("div", null,
                        React.createElement("div", { className: "d-flex mgt-15 viewprofile-section" },
                            React.createElement("div", { className: "DMSanM_14_500 txt-midnight-blue" },
                                React.createElement(Link, { to: "/profile", className: "DMSanM_14_500 txt-midnight-blue lh-140" }, "My Profile")),
                            React.createElement("span", { className: "edel-icon-arrow-right" })))))),
            props.userType === ILoginFlows.GUEST && (React.createElement(React.Fragment, null,
                React.createElement("div", null,
                    React.createElement("div", { className: "signup-block" }, props.userName.substring(0, 3))),
                React.createElement("div", null,
                    React.createElement("span", { className: "DMSan_16_700 txt-midnight-blue" }, props.userName),
                    React.createElement("div", { className: "d-flex mgt-15" },
                        React.createElement("span", { className: "DMSanN_14_400 txt_primaryGrey" }, "Cust ID"),
                        React.createElement("span", { className: "DMSanM_14_500 ps-2 txt_blackOne1" }, "45015214")),
                    React.createElement("div", { className: "d-flex mgt-15" },
                        React.createElement("span", { className: "DMSanN_14_400 txt_primaryGrey" }, "Advisor"),
                        React.createElement("span", { className: "DMSanM_14_500 ps-2 txt-midnight-blue txt_underline" }, "Rahul Bhattacharya")),
                    React.createElement("div", null,
                        React.createElement("div", { className: "d-flex mgt-15 viewprofile-section" },
                            React.createElement("div", { className: "DMSanM_14_500 txt-midnight-blue" },
                                React.createElement(Link, { to: "/profile", className: "DMSanM_14_500 txt-midnight-blue lh-140" }, "My Profile")),
                            React.createElement("span", { className: "edel-icon-arrow-right" })))))))));
};
export default LoginLogoutsection;
